import ContractInsuranceEntitiesPanel from './ContractInsuranceEntitiesPanel';

export default ContractInsuranceEntitiesPanel;
